import { showDeviceTips } from '@/assets/js/common.js';
import { audioContextObj } from '@/assets/js/audioContext';
export default {
  props: {
    osLevelmicMuted: {
      type: Boolean,
      default: false
    },
    mic: {
      type: Boolean,
      default: false
    },
    microphoneId: {
      type: String,
      default: ''
    },
    localVolume: {
      type: Number,
      default: 0
    },
    devicesInfo: {
      type: Object,
      default: () => {}
    },
    rtc: {
      type: Object,
      default: () => {}
    }
  },
  setup() {
    return {
      showDeviceTips
    };
  },
  computed: {
    returnClass() {
      return this.showCheckTips && !this.mic ? 'audioCheckTip' : '';
    },
    returnManual() {
      return !this.mic && this.showCheckTips;
    }
  },
  watch: {
    localVolume(volume) {
      if (this.mic) return;
      if (volume > 0.2) {
        this.cancelCheckTime = 0;
        if (this.startCheckTime === 0) {
          this.startCheckTime = new Date().getTime();
        } else {
          // 连续三秒声音过大则显示提示
          if (new Date().getTime() - this.startCheckTime >= 3000) {
            if (!this.hasClose) {
              this.visiable = true;
              this.showCheckTips = true;
            }
          }
        }
      } else {
        if (this.cancelCheckTime === 0) {
          this.cancelCheckTime = new Date().getTime();
        } else {
          // 连续三秒声音过小则隐藏提示
          if (new Date().getTime() - this.cancelCheckTime >= 3000) {
            this.visiable = false;
            // 为了优化离开后的效果
            setTimeout(() => {
              this.startCheckTime = 0;
              this.showCheckTips = false;
            }, 500);
          }
        }
      }
    },
    mic: {
      async handler(val) {
        if (val) {
          this.visiable = false;
          this.showCheckTips = false;
          this.hasChangeStatus = false;
          this.hasClose = false;
          this.startCheckTime = 0;
          this.cancelCheckTime = 0;
          if (this.localAudioTrack) {
            this.localAudioTrack.close();
            this.localAudioTrack = null;
          }
          if (this.audioContextObj && this.audioContextObj.state != 'closed') this.audioContextObj.close();
          this.animationObj && cancelAnimationFrame(this.animationObj);
        } else {
          if (!this.hasCreateLocalAudioTrack && this.rtc) {
            this.hasCreateLocalAudioTrack = true;
            try {
              await this.createLocalAudioTrack();
              this.addAudioContext();
            } catch (error) {
              console.log('createLocalAudioTrack', error);
            }
          }
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      visiable: false,
      showCheckTips: false,
      hasChangeStatus: false,
      hasClose: false,
      startCheckTime: 0,
      cancelCheckTime: 0,
      localAudioTrack: null,
      audioContextObj: null,
      animationObj: null,
      hasCreateLocalAudioTrack: false // 初始化 mic 是 unenable 时不会有 audiotrack 创建
    };
  },

  methods: {
    async createLocalAudioTrack() {
      if (this.rtc && Object.keys(this.rtc).length !== 0 && this.microphoneId && !this.rtc._localAudioTrack && this.rtc._AgoraRTC && !this.devicesInfo.microphoneError) {
        if (this.localAudioTrack) this.localAudioTrack.close();
        this.localAudioTrack = await this.rtc._AgoraRTC.createMicrophoneAudioTrack({
          AEC: true,
          // 回声消除
          ANS: true,
          // 噪声抑制
          microphoneId: this.microphoneId // 指定麦克风
        }).catch(err => {
          console.log('createLocalAudioTrack', err);
        });
      }
    },
    addAudioContext() {
      const localAudioTrack = this.localAudioTrack;
      if (!this.mic && localAudioTrack && localAudioTrack._mediaStreamTrack) {
        const media = new MediaStream();
        if (localAudioTrack._mediaStreamTrack instanceof MediaStreamTrack) {
          media.addTrack(localAudioTrack._mediaStreamTrack);
          audioContextObj.audioTrack(media, 'volume', (volume, audioContext, animationObj) => {
            this.audioContextObj = audioContext;
            this.animationObj = animationObj;
            if (volume > 0.2) {
              this.cancelCheckTime = 0;
              if (this.startCheckTime === 0) {
                this.startCheckTime = new Date().getTime();
              } else {
                // 连续三秒声音过大则显示提示
                if (new Date().getTime() - this.startCheckTime >= 3000) {
                  if (!this.hasClose) {
                    this.visiable = true;
                    this.showCheckTips = true;
                  }
                }
              }
            } else {
              if (this.cancelCheckTime === 0) {
                this.cancelCheckTime = new Date().getTime();
              } else {
                // 连续三秒声音过小则隐藏提示
                if (new Date().getTime() - this.cancelCheckTime >= 3000) {
                  this.visiable = false;
                  // 为了优化离开后的效果
                  setTimeout(() => {
                    this.startCheckTime = 0;
                    this.showCheckTips = false;
                  }, 500);
                }
              }
            }
          });
          setTimeout(() => {
            audioContextObj.resumeAudio('volume');
          }, 1000);
        }
      }
    },
    setMic(val) {
      this.$emit('callback', val);
    },
    close() {
      this.visiable = false;
      this.hasClose = true;
    }
  }
};